import { render, staticRenderFns } from "./CommunityTransactions.vue?vue&type=template&id=52ecf2ef&scoped=true&"
import script from "./CommunityTransactions.vue?vue&type=script&lang=js&"
export * from "./CommunityTransactions.vue?vue&type=script&lang=js&"
import style0 from "./CommunityTransactions.vue?vue&type=style&index=0&id=52ecf2ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecf2ef",
  null
  
)

export default component.exports